import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../../components/layout/ShowocaseLayout';

export default [
  <Route key="/business/showcase/skincare/diagnostics" element={<ShowocaseLayout />}>
    <Route path="business/showcase/skincare/diagnostics" element={<AsyncPage />} />
  </Route>,
  <Route
    key="/business/showcase/skincare/live-diagnostics"
    element={<ShowocaseLayout />}
  >
    <Route
      path="business/showcase/skincare/live-diagnostics"
      element={<AsyncPage />}
    />
  </Route>,
];
